import React from "react";
import { ArrowLeft, ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

export default function CartHeader({ cartCount }) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/menu"); // 👈 you can change this route as needed
  };

  return (
    <div className="main-header">
      <div className="main-header-left" onClick={handleBack}>
        <ArrowLeft size={22} className="main-back-icon" />
      </div>

      <span className="main-header-title">Fliplyn</span>

      <div className="main-cart-icon">
        <ShoppingCart size={24} />
        {cartCount > 0 && <span className="main-cart-badge">{cartCount}</span>}
      </div>
    </div>
  );
}
